import { RequestPerformer } from '@/api/api-requests-factory';
import { AuthApiResources } from '@/api/auth';
import { useEnvStore } from '@/store/env.store';
import { storeToRefs } from 'pinia';
import { ReportApiResources } from '@/api/report';
import { DictionaryApiResources } from '@/api/dictionary';
import { MgaRealMoneyBalanceApiResources } from '@/api/mga-real-money-balance';
import { TimestampApiResources } from '@/api/timestamp';

export interface ApiResources {
  auth: AuthApiResources;
  report: ReportApiResources;
  dictionary: DictionaryApiResources;
  mgaRealMoneyBalance: MgaRealMoneyBalanceApiResources;
  timestamp: TimestampApiResources;
}

export class ApiResourcesFactory {
  public getInstance(basePerformer: RequestPerformer): ApiResources {
    const { BACKOFFICE_API_URL, MULTIBRAND_API_URL } = storeToRefs(useEnvStore());

    return {
      auth: new AuthApiResources(basePerformer, BACKOFFICE_API_URL),
      report: new ReportApiResources(basePerformer, BACKOFFICE_API_URL),
      dictionary: new DictionaryApiResources(basePerformer, BACKOFFICE_API_URL, MULTIBRAND_API_URL),
      mgaRealMoneyBalance: new MgaRealMoneyBalanceApiResources(basePerformer, BACKOFFICE_API_URL),
      timestamp: new TimestampApiResources(basePerformer, BACKOFFICE_API_URL),
    };
  }
}
